import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import './styles/navigation.css';

const Navigation = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <nav className="navigation">
            <div className="nav-content">
                <div className="nav-logo">
                    <Link to="/" onClick={closeMenu}>
                        Pasmo
                    </Link>
                </div>

                {/* Mobile menu button */}
                <button className="mobile-menu-btn" onClick={toggleMenu} aria-label="Toggle navigation menu">
                    <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
                </button>

                {/* Navigation links */}
                <div className={`nav-links ${isOpen ? 'active' : ''}`}>
                    <Link 
                        to="/" 
                        className={isActive('/') ? 'active' : ''} 
                        onClick={closeMenu}
                    >
                        Home
                    </Link>
                    <Link 
                        to="/about" 
                        className={isActive('/about') ? 'active' : ''} 
                        onClick={closeMenu}
                    >
                        About
                    </Link>
                    <Link 
                        to="/services" 
                        className={isActive('/services') ? 'active' : ''} 
                        onClick={closeMenu}
                    >
                        Services
                    </Link>
                    <Link 
                        to="/articles" 
                        className={isActive('/articles') ? 'active' : ''} 
                        onClick={closeMenu}
                    >
                        Blog
                    </Link>
                    <Link 
                        to="/contact" 
                        className={isActive('/contact') ? 'active' : ''} 
                        onClick={closeMenu}
                    >
                        Contact
                    </Link>
                </div>
            </div>
        </nav>
    );
};

export default Navigation; 